import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchPlansActive, fetchPlansArchive } from '@/api/capa';
import type { PlansQuickFilter } from '../-types';

interface UsePlansQueryParams {
  isArchiveView: boolean;
  quickFilter: PlansQuickFilter;
  page: number;
  count: number;
  sort?: string;
  filters?: Record<string, string[]>;
}

function buildQs(params: UsePlansQueryParams): string {
  const qs = new URLSearchParams();
  qs.set('page', String(Math.max(0, params.page - 1)));
  qs.set('count', String(params.count));
  if (params.sort) qs.set('sort', params.sort);
  if (params.quickFilter && params.quickFilter !== 'all') {
    qs.set('quickFilter', params.quickFilter);
  }
  if (params.filters && Object.keys(params.filters).length > 0) {
    const flat: Record<string, string> = {};
    for (const [key, vals] of Object.entries(params.filters)) {
      if (vals.length === 0) continue;
      if (key === 'createdAt' || key === 'updatedAt') {
        const [from, to] = vals;
        if (from) flat[`${key}From`] = from;
        if (to) flat[`${key}To`] = to;
        continue;
      }
      flat[key] =
        key === 'tags' || key === 'collaboratorIds' ? vals.join(',') : vals[0]!;
    }
    if (Object.keys(flat).length > 0) qs.set('filter', JSON.stringify(flat));
  }
  return qs.toString();
}

export function plansQueryOptions(params: UsePlansQueryParams) {
  const qs = buildQs(params);
  return {
    queryKey: [
      'capa-plans',
      {
        isArchiveView: params.isArchiveView,
        quickFilter: params.quickFilter,
        page: params.page,
        count: params.count,
        sort: params.sort,
        filters: params.filters,
      },
    ] as const,
    queryFn: () =>
      params.isArchiveView ? fetchPlansArchive(qs) : fetchPlansActive(qs),
  };
}

export function usePlansQuery(params: UsePlansQueryParams) {
  return useQuery({
    ...plansQueryOptions(params),
    placeholderData: keepPreviousData,
  });
}
